module.exports = __webpack_public_path__ + "img/banner-station.072422d5.png";